import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Card, Grid, Heading, Button } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { CancelIcon, CautionFilledIcon, InfoFilledIcon, ErrorFilledIcon, CheckCircleFilledIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default, { useRef } from 'react';

var _excluded = ["as", "className", "children", "onClose", "heading", "data-testid", "type"];
var Alert = function Alert(_ref) {
  _ref.as;
    var className = _ref.className,
    children = _ref.children,
    onClose = _ref.onClose,
    heading = _ref.heading,
    dataTestId = _ref['data-testid'],
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var accessibilityHeading = useRef(/*#__PURE__*/React__default.createRef());
  var typeIcons = {
    alert: CautionFilledIcon,
    "default": InfoFilledIcon,
    error: ErrorFilledIcon,
    success: CheckCircleFilledIcon
  };
  var finalClasses = classnames('C-Alert hc-pa-normal', _defineProperty({}, "--type-".concat(type), type), className);
  var retainFocusForAccessibility = function retainFocusForAccessibility() {
    accessibilityHeading.current && accessibilityHeading.current.focus();
  };
  return /*#__PURE__*/React__default.createElement(Card, _extends({
    className: finalClasses,
    "data-testid": dataTestId,
    onClose: onClose,
    role: type === 'alert' || 'error' || 'success' ? 'alert' : 'status'
  }, otherProps), /*#__PURE__*/React__default.createElement(Grid.Container, {
    justify: "space-between",
    className: "hc-clr-inherit"
  }, /*#__PURE__*/React__default.createElement(Grid.Item, {
    className: "hc-clr-inherit hc-pr-dense"
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: typeIcons[type],
    size: "md"
  })), /*#__PURE__*/React__default.createElement(Grid.Item, {
    xs: true,
    className: "hc-pl-dense"
  }, /*#__PURE__*/React__default.createElement(Heading, {
    size: 5,
    className: "C-Alert__Header hc-lh-normal",
    ref: accessibilityHeading,
    role: "heading",
    "aria-level": "2",
    "aria-label": "".concat(heading)
  }, heading), /*#__PURE__*/React__default.createElement("div", {
    className: "C-Alert__Message",
    role: type === 'alert' || 'error' || 'success' ? 'alert' : 'status'
  }, children)), onClose ? /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(Button, {
    type: "ghost",
    iconOnly: true,
    "aria-label": "Close Alert",
    className: "C-Alert__Exit hc-ml-dense",
    size: "dense",
    onClick: onClose,
    "data-testid": otherProps['data-testid'] ? "".concat(otherProps['data-testid'], "_closeButton") : null
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: CancelIcon
  }))) : null, /*#__PURE__*/React__default.createElement("span", {
    tabIndex: "0",
    onFocus: retainFocusForAccessibility
  })));
};
Alert.displayName = 'Alert';

export { Alert as default };
